import { useHelpersStore } from "@/aygulyazilim/store/useHelpers"
import { router } from "@/plugins/1.router"
import axios from "axios"


const api = axios.create({
  baseURL: import.meta.env.VITE_API_ENDPOINT,
  timeout: 60000 * 5, // 5 dakika
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    "Content-Type": "application/json",
    charset: "UTF-8",
  },
})

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem(
      import.meta.env.VITE_APP_TITLE + "-token",
    )

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    // Dinamik lang header
    config.headers.lang = 'tr'

    return config
  },
  error => {
    return Promise.reject(error)
  },
)

// Response interceptor
api.interceptors.response.use(
  response => {
    return response
  },
  error => {
    const t = key => key

    if (error.response) {
      switch (error.response?.status) {
      case 400:
        useHelpersStore().toast(
          "error",
          t(error.response.data.message || error.response.data.error || "Bad Request"),
        )
        break
      case 401:
        localStorage.removeItem(import.meta.env.VITE_APP_TITLE + "-token")
        if (router.currentRoute.value.name !== 'login') {
          router.push({ name: "login" })
        }
        break
      case 403:
      case 404:
      case 500:
        useHelpersStore().toast(
          "error",
          t(error.response.data.message),
        )
        break
      case 422:
        if (error.response.data.errors) {
          for (var key in error.response.data.errors) {
            if (error.response.data.errors.hasOwnProperty(key)) {
              useHelpersStore().toast(
                "error",
                t(error.response.data.errors[key][0]),
              )
            }
          }
        } else {
          useHelpersStore().toast(
            "error",
            t(error.response.data.message),
          )
        }
        break
      default:
        useHelpersStore().toast(
          "error",
          t(error.response.data.message),
        )

        return Promise.reject(error)
      }
    } else if (error.request) {
      // İstek yapıldı ama yanıt alınamadı
    } else {
      useHelpersStore().toast(
        "error",
        "Beklenmeyen bir hata oluştu.",
      )
    }

    return Promise.reject(error)
  },
)

export default api
